import {
  SearchFilterType,
  renderFilterComponent,
  type SearchFilter,
} from '@aibees/elephant/feature/search-filters';

export function useRenderChildrenFilter(item: SearchFilter, open: boolean) {
  if (item.type === SearchFilterType.NONE && item.items)
    return item.items?.map((x) => {
      return renderFilterComponent(x, open, x.sections);
    });
  return renderFilterComponent(item, open, item.sections);
}
